import * as z from 'zod';

import { timesheetDocumentSummaryDtoSchema } from '@/api/gen';

export const entrySchema = z.object({
  id: z.number(),
  fromTime: z.coerce.date(),
  toTime: z.coerce.date(),
  effectiveHours: z.number().positive(),
  projectId: z.number().nullable(),
  projectName: z.string().nullable(),
  customerId: z.number(),
  customerName: z.string(),
  description: z.string().nullish().optional(),
  km: z.number().nullish().optional(),
  extraCosts: z.number().nullish().optional(),
  costsDescription: z.string().nullish().optional(),
  documents: z.array(timesheetDocumentSummaryDtoSchema).optional(),
});

export const entriesSchema = z.array(entrySchema);

export type Entry = z.infer<typeof entrySchema>;

export const dayEntrySchema = z.object({
  date: z.date(),
  entries: z.array(entrySchema),
  minutesWorked: z.number(),
  isHoliday: z.boolean(),
  isWeekend: z.boolean(),
  isCurrentMonth: z.boolean(),
  isBusinessDay: z.boolean(),
});

export type DayEntry = z.infer<typeof dayEntrySchema>;

export const monthEntriesSchema = z.array(dayEntrySchema);

export type MonthEntries = z.infer<typeof monthEntriesSchema>;

export const createEntryResultSchema = z.object({
  projectId: z.number().nullish().optional(),
  customerId: z.number().nullish().optional(),
});

export type CreateEntryResult = z.infer<typeof createEntryResultSchema>;
